import { render } from "./SupportTrad.vue?vue&type=template&id=bb193dd2"
import script from "./SupportTrad.vue?vue&type=script&lang=js"
export * from "./SupportTrad.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__